module.exports = __webpack_public_path__ + "static/logo-f8f15175dac82acce3274a103cea6a31.svg";